import Heading from "../../../components/heading/heading.component";
import { DisclaimerContainer } from "./Disclaimer.styles";


const Disclaimer = () => {

  return (
    <DisclaimerContainer className="App login_page">
      <Heading previusPage={'Disclaimer'} />
      <div style={{textAlign:'justify'}}>
      <p>
        Multipiece Exchange Ltd. (“MusicBull”) is a non-regulated exchange for participation units in future music royalties income streams. While we require truthful 
        and reliable information from our Users at all times during their use of the platform, much of the information provided for the function of this trading 
        exchange is provided by third parties, and thus the accuracy or completeness of any information contained herein cannot be guaranteed, and should not be relied 
        upon in connection with any particular issuer’s and/or investor’s trading, nor should any information contained herein be taken or construed as an offer, 
        recommendation, nor solicitation of any form. Further, the information contained herein may not be suitable for all persons. In addition, the information on 
        this platform is not intended for persons who reside in jurisdictions where providing such information would violate the laws or regulations of such jurisdiction. 
        MusicBull disclaims all warranties, express or implied, to the extent permitted by law, excluding those derived from MusicBull’s executed agreements.
      </p>
      <br />
      <p>
        MusicBull does not and cannot provide any investment advice, and only permits Users to use the platform who have read the relevant risk disclosure documents 
        provided herein, and assent to accessing and using the platform wholly at their own risk (whether foreseen or unforeseen). Any decision made by a person to 
        participate in MusicBull’s activities, services, or offerings should be made on the basis that such an activity complies with any applicable local laws and 
        regulations to which the relevant User is subject.
      </p>
      <br />
      <p>
        Trading in participation units of future music royalties involves risks, the result of which may include fluctuations of your investments over time, or the loss 
        or gain of money. Past performance is not in and of itself a reliable guarantee of any future returns, nor should it be considered indicative of future performance.
      </p>
      <br />
      <p>
        The foregoing disclosure cannot and does not claim to be an exhaustive description of all potential risks from MusicBull’s service offerings, or any User’s conduct therefrom. 
        MusicBull highly encourages any and all Users to read the Terms and Conditions (including consulting with independent counsel if deemed necessary) contained herein, as well as 
        any other relevant content contained here which apply to MusicBull’s services, any assets sought after by any User, and the potential risk from your desired investment objectives 
        carefully and wholly before the use of our platform.
      </p>   
      </div>
    </DisclaimerContainer>
  );
}

export default Disclaimer;